import React from 'react';
import styled from 'styled-components';
import loaderImage from './assets/spinner.gif';

export type LoaderProps = {
  active: boolean;
  component?: boolean;
  loader?: string;
};

// tslint:disable-next-line:variable-name
const SLoaderWrap = styled.div<{ component?: boolean }>(({ component }) => ({
  position: component ? 'absolute' : 'fixed',
  zIndex: 10000,
  top: 0,
  left: 0,
  width: component ? '100%' : '100vw',
  height: component ? '100%' : '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  userSelect: 'none',
}));

// tslint:disable-next-line:variable-name
const SLoaderImage = styled.img({
  width: '30%',
  maxWidth: 150,
});

// tslint:disable-next-line:variable-name
const Loader: React.FC<LoaderProps> = (props) => {
  if (!props.active) {
    return null;
  }
  return (
    <SLoaderWrap aria-live="assertive" aria-label="Loading" component={props.component}>
      <SLoaderImage src={props.loader || loaderImage} alt="loading" />
    </SLoaderWrap>
  );
};

export default Loader;
